import Navbar from '../../components/feature/Navbar';
import HeroSection from './components/HeroSection';
import StatsSection from './components/StatsSection';
import CaseListSection from './components/CaseListSection';
import SuccessFactorsSection from './components/SuccessFactorsSection';
import TestimonialsSection from './components/TestimonialsSection';
import CTASection from './components/CTASection';
import { SEO } from '../../utils/seo';

export default function CasesPage() {
  const siteUrl = import.meta.env.VITE_SITE_URL || 'https://example.com';
  
  const jsonLd = {
    '@context': 'https://schema.org',
    '@type': 'WebPage',
    name: '成功事例',
    description: '株式会社G11のM&A成功事例をご紹介。様々な業種・規模の企業のM&A事例から、成功のポイントをご確認いただけます。',
    url: `${siteUrl}/cases`
  };

  return (
    <div className="min-h-screen bg-gray-50">
      <SEO
        title="成功事例 | M&A・事業承継の実績 | 株式会社G11"
        description="株式会社G11のM&A成功事例をご紹介。様々な業種・規模の企業のM&A事例から、成功のポイントをご確認いただけます。製造業、IT業、飲食業など多数の実績。"
        keywords="M&A事例,成功事例,事業承継事例,企業買収事例,会社売却事例"
        jsonLd={jsonLd}
      />
      <Navbar />
      <HeroSection />
      <StatsSection />
      <CaseListSection />
      <SuccessFactorsSection />
      <TestimonialsSection />
      <CTASection />
    </div>
  );
}
